import { SWRConfiguration } from 'swr';

import { CollaborationWorkListTemplate } from '~/data/collaboration/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

const GET_COLLABORATION_WORKLIST_TEMPLATES =
  'GET_COLLABORATION_WORKLIST_TEMPLATES';

const getCollaborationWorkListTemplate = async (
  workListId: number,
  language?: string,
): Promise<CollaborationWorkListTemplate> => {
  const resolveParams = (): string => {
    const params: string[] = ['format=FULL'];

    if (!!language) {
      params.push(`langIso=${language}`);
    }

    return params.length > 0 ? `?${params.join('&')}` : '';
  };

  return fetchFromOldApi(
    `/json/collab/template/${workListId}${resolveParams()}`,
  ).then((r) => r.json());
};

export const useGetCollaborationWorkListTemplates = (
  props: {
    workListIds: number[];
    language?: string;
  },
  swrConfig?: SWRConfiguration,
): UseArraySWROutput<CollaborationWorkListTemplate> => {
  const { workListIds, language } = props;

  return useArraySWR(
    workListIds.length > 0
      ? [GET_COLLABORATION_WORKLIST_TEMPLATES, workListIds, language]
      : null,
    ([_, workListIds, language]: [string, number[], string | undefined]) =>
      Promise.all(
        workListIds.map((id) => getCollaborationWorkListTemplate(id, language)),
      ),
    swrConfig,
  );
};
